import { render, staticRenderFns } from "./BaseArticlePage.vue?vue&type=template&id=7be9c07c&"
import script from "./BaseArticlePage.vue?vue&type=script&lang=js&"
export * from "./BaseArticlePage.vue?vue&type=script&lang=js&"
import style0 from "./BaseArticlePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports